module.exports = __webpack_public_path__ + "img/icon_home00_hover.ff8c08be.png";